import type {FetchError} from 'ofetch';
import {showError, defineNuxtPlugin, useUniversalPost, useRoute} from '#imports';

export default defineNuxtPlugin((nuxt) => {
    nuxt.hook('page:finish', async () => {
        // MT-385 & MT-387: enable Prismic preview
        // Enable by-pass for /slice-simulator and /cms/prismic/preview
        const route = useRoute();
        if (route.meta?.cookieVerifierSkip) {
            return;
        }

        try {
            await useUniversalPost<any>('/cookie-verify', {baseURL: '/'});
        } catch (e) {
            const error = e as FetchError;
            if (error.status === 403) {
                showError({message: '(cookie-verifier) Cookie are not working properly', data: {type: 'cookie-verify'}});
            }
        }
    });
});
